import { format } from "date-fns"
import { it } from 'date-fns/locale/it'
import React, { useEffect, useRef, useState } from "react"
import InfiniteScroll from 'react-infinite-scroll-component'
import { keycloak } from "../../../lib/keycloak/index.ts"
import { setFindDocumentStatus } from "../../../lib/object/slice.ts"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hook.ts"
import { colors } from "../../../ui/colors.ts"
import { AccountantIcon } from "../../../ui/icons/accountantIcon.tsx"
import { ArrowRightIcon } from "../../../ui/icons/arrowRightIcon.tsx"
import { BalanceIcon } from "../../../ui/icons/balanceIcon.tsx"
import { CompanyIcon } from "../../../ui/icons/companyIcon.tsx"
import { EmployeeIcon } from "../../../ui/icons/employeeIcon.tsx"
import { F24Icon } from "../../../ui/icons/f24Icon.tsx"
import { OtherIcon } from "../../../ui/icons/otherIcon.tsx"
import PaperClipIcon from "../../../ui/icons/paperClipIcon.tsx"
import { ButtonComponent } from "../../../ui/molecules/button/index.tsx"
import { SpinnerComponent } from "../../../ui/molecules/spinner/index.tsx"
import { InfoTextPopup } from "../../../ui/organisms/infoTextPopup/index.tsx"
import { findByUserId } from "../../auth/slice.ts"
import { AddDocumentsModal } from "../documents/addDocumentsModal.tsx"
import { findByIdDocument, setFindByIdDocumentStatus, setOpenAddDocumentsModal, setSaveDocumentStatus } from "../documents/slice.ts"
import { CompanyStatus } from "../dto.ts"
import { MessageDTO, MessageType } from "./dto.ts"
import { MessageComponent } from "./message.tsx"
import { findChats, findMessages, setChatList, setChatSeen, setChatSeenStatus, setSelectedChat, setUsersListAfterSend, unSeenMessages } from "./slice.ts"
import "./style.css"
import { setSocket, urlMap } from "../../../lib/keycloak/slice.ts"


export function ChatComponent() {
    const layoutState = useAppSelector(state => state.layout)
    const chatState = useAppSelector(state => state.chat)
    const keycloakState = useAppSelector(state => state.secured)
    const companyState = useAppSelector(state => state.company)
    const authState = useAppSelector(state => state.auth)
    const documentState = useAppSelector(state => state.document)
    const dispatch = useAppDispatch()

    const [page, setPage] = useState<number>(0)
    const [messages, setMessages] = useState<MessageDTO[]>([])
    const [textMessage, setTextMessage] = useState<string>('')
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [wrote, setWrote] = useState(false)
    const [type, setType] = useState<"balance" | "f24" | "employee" | "accountant" | "other">()

    const menuRef = useRef(null);
    const iconRef = useRef(null);
    const messagesRef = useRef(null)

    useEffect(() => {
        if (keycloakState.socket?.readyState !== 1) {
            dispatch(setSocket(new WebSocket(urlMap.get(window.location.origin) + "/chat", ["access-token", keycloak.token || ''])))
        }
    }, [keycloakState.socket?.readyState])
 
    useEffect(() => {
        keycloakState.socket?.close()
        dispatch(setSocket(new WebSocket(urlMap.get(window.location.origin) + "/chat", ["access-token", keycloak.token || ''])))
    }, [keycloak.token])

    useEffect(() => {
        setPage(0)
        setMessages([])
        setTextMessage("")
    }, [chatState.selectedChat])

    useEffect(() => {
        if (!keycloakState.socket || keycloakState.socket.readyState !== 1)
            dispatch(setSocket(new WebSocket(urlMap.get(window.location.origin) + "/chat", ["access-token", keycloak.token || ''])))
    }, [])

    useEffect(() => {
        if (wrote) {
            const id = setTimeout(() => {
                setWrote(false)
            }, 3000);
            return () => clearTimeout(id)
        }
    }, [wrote])

    useEffect(() => {
        const topic = keycloak.hasRealmRole('company') ? authState.findMeCompanyResponse?.id : authState.findMeReferrersResponse?.company
        if (keycloak.hasRealmRole('company') || keycloak.hasRealmRole('administrative_company')) {
            if (topic)
                dispatch(findChats(topic))
        }
    }, [])

    useEffect(() => {
        if (chatState.setChatSeenStatus === 'successfully') {
            dispatch(setChatSeenStatus('idle'))
            dispatch(unSeenMessages(chatState.selectedChat.toString()))
        }
    }, [chatState.setChatSeenStatus])

    useEffect(() => {
        let userList: string[] = []
        if ((keycloak.hasRealmRole('company') || keycloak.hasRealmRole('administrative_company')) && chatState.findChatResponse && chatState.findChatResponse.length > 0) {
            const chat = chatState.findChatResponse[0]
            const chatDetail = {
            chat: chat,
            name: 'Chat azienda',
            icon: <CompanyIcon size={"24"} color={layoutState.theme[50]} />,
            members: chat?.users.length,
        }
            dispatch(setSelectedChat(chat.id))
            if (keycloak.hasRealmRole('company'))
                setMessages([])
            dispatch(findMessages({
                chatId: chat.id,
                filter:
                {
                    page: 0,
                    itemsPerPage: (chat && chat.notSeenMessages > 0 ? (chat.notSeenMessages + 25) : 25),
                    order: chatState.messageFilter.order,
                    sort: chatState.messageFilter.sort
                }
            }))
            if (chatState.findChatsStatus === 'successfully') {
                chatState.findChatResponse.forEach(user => {
                    user.users.forEach(userId => {
                        if (!user.active) {
                            userList.push('')
                        } else if (!userList.includes(userId)) {
                            userList.push(userId)
                        }
                    })
                })
            }
            if (chatState.usersListAfterSend.length === 0)
                dispatch(findByUserId(userList))
            dispatch(setUsersListAfterSend([...userList]))
            dispatch(setChatSeen(chat.id))
            dispatch(setChatList(chatDetail))
            if (chatState.usersListAfterSend.length === 0)
                dispatch(findByUserId(userList))
            dispatch(setUsersListAfterSend([...userList]))
        }
    }, [chatState.findChatResponse])

    useEffect(() => {
        if (
            chatState.findMessagesStatus === 'successfully' &&
            chatState.findMessagesResponse !== undefined &&
            chatState.findMessagesResponse.data !== undefined &&
            chatState.findMessagesResponse.data.length > 0
        ) {
            let messagesList = [...chatState.findMessagesResponse.data]
            chatState.findMessagesResponse.data.forEach((message, index) => {
                messagesList.concat(
                    message
                )
            })
            setMessages(prev => [...prev, ...messagesList])
            if (chatState.findMessagesResponse.page > 0) {
                //@ts-ignore
                messagesRef.current?.lastElementChild?.lastElementChild?.scrollIntoView({ block: 'start' })
            }
        }
    }, [chatState.findMessagesStatus])

    useEffect(() => {
        if (documentState.saveDocumentStatus === "successfully" && documentState.saveDocumentResponse !== undefined) {
            dispatch(findByIdDocument(documentState.saveDocumentResponse))
            dispatch(setSaveDocumentStatus('idle'))
        }
    }, [documentState.saveDocumentStatus])

    useEffect(() => {
        if (documentState.findByIdDocumentStatus === "successfully" && documentState.findByIdDocumentResponse !== undefined) {
            if (keycloak.tokenParsed !== undefined && keycloak.tokenParsed.exp !== undefined) {
                if (keycloakState.socket && keycloakState.socket.readyState === keycloakState.socket.OPEN) {
                    documentState.findByIdDocumentResponse.forEach((item) => {
                        keycloakState.socket?.send(chatState.selectedChat + '£>' + item.objectId + ';' + item.fileName + '£>' + MessageType.media)
                        dispatch(setFindByIdDocumentStatus('idle'))
                        setTimeout(() => {
                            setMessages([])
                            dispatch(findMessages({ chatId: chatState.selectedChat, filter: { page: 0, itemsPerPage: (chat && chat.notSeenMessages > 0 ? (chat.notSeenMessages + 25) : 25), order: chatState.messageFilter.order, sort: chatState.messageFilter.sort } }))
                            dispatch(findByUserId(chatState.usersListAfterSend))
                            dispatch(findChats(companyState.findByIdCompanyResponse?.id ?? authState.findMeCompanyResponse?.id!))
                        }, 200)
                    })
                }
            }
            dispatch(setFindDocumentStatus("idle"))
        }
    }, [documentState.findByIdDocumentStatus])

    if (keycloakState.socket === undefined) {
        return <></>
    }

    keycloakState.socket.onmessage = () => {
        if (chatState.selectedChat !== 0 && chatState.findChatResponse) {
            const chat = chatState.findChatResponse.find(chat => chat.id === chatState.selectedChat)
            setMessages([])
            dispatch(findMessages({ chatId: chatState.selectedChat, filter: { page: 0, itemsPerPage: (chat && chat.notSeenMessages > 0 ? (chat.notSeenMessages + 25) : 25), order: chatState.messageFilter.order, sort: chatState.messageFilter.sort } }))
        }
        dispatch(findChats(companyState.findByIdCompanyResponse?.id ?? authState.findMeCompanyResponse?.id!))
    }

    const chat = chatState.findChatResponse ? chatState.findChatResponse.find(chat => chat.id === chatState.selectedChat) : undefined

    return (
        <div style={{
            height: '100%',
            backgroundColor: colors.white,
            width: '100%',
            borderTopLeftRadius: window.location.pathname.includes('operation') ? 0 : 12,
            borderBottomLeftRadius: window.location.pathname.includes('operation') ? 0 : 12,
            borderRadius: 12,
            // border: '1px solid ' + colors.neutral[200],
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: 0
        }}>
            {
                chatState.selectedChat === 0 ? (
                    <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} className='text-text-md font-medium text-neutral-700'>
                        Seleziona una chat.
                    </div>
                ) : (
                    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div className=" border-b border-b-neutral-100 flex items-center justify-between px-4 py-3">
                            <div className="flex flex-row items-center gap-3 flex-grow">
                                <div className="w-[48px] h-[48px] rounded-[240px] flex justify-center items-center" style={{ backgroundColor: layoutState.theme[500] }}>
                                    {chatState.chatList?.icon}
                                </div>
                                <div className="flex flex-col gap-1">
                                    <span className="text-text-md font-bold text-neutral-800">
                                        {chatState.chatList?.name}
                                    </span>
                                    {authState.findByUserIdResponse && <InfoTextPopup label={authState.findByUserIdResponse.filter(elem => chat?.users.includes(elem.userId)).map(item =>
                                        item.role === 'company' ? item.businessName :
                                            (item.name ? (item.name + " " + item.surname) : item.businessName)).join(', ')} children={<span className="text-text-sm font-normal text-neutral-500">
                                                {chatState.chatList?.members + " membri"}
                                            </span>} position={"bottom"} />}
                                </div>
                            </div>
                        </div>
                        <div
                            className="newChat"
                            style={{
                                margin: 'auto',
                                padding: 32,
                                position: 'relative',
                                height: 'calc(100% - 147.98px)',
                                width: '100%'
                            }}
                        >
                            {
                                chatState.findMessagesStatus === 'loading' ?
                                    <div className="flex justify-center items-center h-full">
                                        <SpinnerComponent />
                                    </div>
                                    :
                                    <div id='scrollableDivMessages' className=" scrollbar-hidden" ref={messagesRef} style={{ display: 'flex', flexDirection: "column-reverse", overflow: "scroll", height: '100%' }}>
                                        <InfiniteScroll
                                            key={chatState.selectedChat + '-chat-list-message'}
                                            inverse
                                            style={{ display: 'flex', flexDirection: 'column-reverse', margin: 'auto', marginBottom: 4, width: '80%' }}
                                            scrollableTarget="scrollableDivMessages"
                                            dataLength={messages.length}
                                            next={() => {
                                                if (chatState.findMessagesStatus !== 'loading') {
                                                    dispatch(findMessages({ chatId: chatState.selectedChat, filter: { page: page + 1, itemsPerPage: (chat && chat.notSeenMessages > 0 ? (chat.notSeenMessages + 25) : 25), order: chatState.messageFilter.order, sort: chatState.messageFilter.sort } }))
                                                    setPage(page + 1)
                                                }
                                            }}
                                            hasMore={(chatState.findMessagesResponse?.next && !wrote) || false}
                                            endMessage={
                                                <span className='text-text-md font-semibold text-neutral-800 text-center p-4'>
                                                    {chatState.findMessagesResponse?.total === 0 ? 'Non sono presenti altri messaggi' : ''}
                                                </span>
                                            }
                                            loader={
                                                <div
                                                    style={{
                                                        width: '100%',
                                                        padding: 10,
                                                        margin: 0,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <SpinnerComponent />
                                                </div>
                                            }
                                        >
                                            {
                                                messages.map((message, index) => (
                                                    <div
                                                        key={message.id}
                                                        style={{
                                                            display: 'flex',
                                                            gap: '8px',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            alignSelf: 'stretch',
                                                            borderRadius: '6px',
                                                            width: '100%',
                                                            padding: (
                                                                (
                                                                    messages[index + 1] &&
                                                                    messages[index + 1].sender === message.sender &&
                                                                    format(new Date(message.timestamp), 'dd/MM/yyyy') === format(new Date(messages[index + 1].timestamp), 'dd/MM/yyyy')
                                                                ) || (
                                                                        messages[index - 1] &&
                                                                        messages[index - 1].sender === message.sender &&
                                                                        format(new Date(message.timestamp), 'dd/MM/yyyy') === format(new Date(messages[index - 1].timestamp), 'dd/MM/yyyy')
                                                                    ) ? '2px 0' : '8px 4px')
                                                        }}>
                                                        {
                                                            (!messages[index + 1] || (messages[index + 1] && format(new Date(message.timestamp), 'dd/MM/yyyy') !== format(new Date(messages[index + 1].timestamp), 'dd/MM/yyyy'))) &&
                                                            <span className='text-text-md font-medium text-neutral-750'>
                                                                {new Date().getFullYear() === new Date(message.timestamp).getFullYear() && (format(new Date(message.timestamp), 'eee ', { locale: it }))}
                                                                {(format(new Date(message.timestamp), 'dd MMM', { locale: it }))}
                                                                {new Date().getFullYear() !== new Date(message.timestamp).getFullYear() && format(new Date(message.timestamp), ' yyyy')}
                                                            </span>
                                                        }
                                                        <div className="text-text-lg font-medium text-neutral-800"
                                                            style={{ flexGrow: 1, maxWidth: '75%', alignSelf: (message.sender === keycloak.subject ? 'flex-end' : 'flex-start') }}>
                                                            <MessageComponent
                                                                sameSanderAsPrevious={
                                                                    messages[index + 1] &&
                                                                    messages[index + 1].sender === message.sender &&
                                                                    format(new Date(message.timestamp), 'dd/MM/yyyy') === format(new Date(messages[index + 1].timestamp), 'dd/MM/yyyy')
                                                                }
                                                                message={message.message}
                                                                sender={authState.findByUserIdResponse?.find(user => user.userId === message.sender)}
                                                                sent={message.sender === keycloak.subject}
                                                                date={message.timestamp}
                                                                type={message.type}
                                                            />
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </InfiniteScroll>
                                    </div>
                            }
                        </div>
                        <div className=" px-8 pb-6 pt-2 gap-2 flex flex-row items-center relative w-[80%] m-auto h-[72px]">
                            {isMenuOpen && (
                                <div
                                    ref={menuRef}
                                    className="absolute bottom-full bg-white shadow-lg rounded-xl p-2 w-70 gap-1 flex flex-col justify-start items-start"
                                    style={{
                                        position: 'absolute',
                                        right: 100,
                                        zIndex: 100,
                                    }}
                                >
                                    <span className="text-text-sm font-normal text-neutral-500">Scegli il tipo di documento da inviare</span>
                                    <ButtonComponent
                                        iconSize={20}
                                        icon={<BalanceIcon size={"20"} color={colors.brandPrimary[500]} />}
                                        size={"sm"}
                                        iconPosition={"left"}
                                        variant={"link"}
                                        color={"gray"}
                                        label="Bilanci e Dichiarativi"
                                        onClick={() => {
                                            setIsMenuOpen(false)
                                            setType("balance")
                                            dispatch(setOpenAddDocumentsModal(true))
                                        }}
                                    />
                                    <ButtonComponent
                                        iconSize={20}
                                        icon={<F24Icon size={"20"}
                                            color={colors.brandPrimary[500]} />}
                                        size={"sm"}
                                        iconPosition={"left"}
                                        variant={"link"}
                                        color={"gray"}
                                        label="F24"
                                        onClick={() => {
                                            setIsMenuOpen(false)
                                            setType("f24")
                                            dispatch(setOpenAddDocumentsModal(true))
                                        }}
                                    />
                                    <ButtonComponent
                                        iconSize={20}
                                        icon={<EmployeeIcon size={"20"} color={colors.brandPrimary[500]} />}
                                        size={"sm"}
                                        iconPosition={"left"}
                                        variant={"link"}
                                        color={"gray"}
                                        label="Dipendenti"
                                        onClick={() => {
                                            setIsMenuOpen(false)
                                            setType("employee")
                                            dispatch(setOpenAddDocumentsModal(true))
                                        }}
                                    />
                                    <ButtonComponent
                                        iconSize={20}
                                        icon={<OtherIcon size={"20"} color={colors.brandPrimary[500]} />}
                                        size={"sm"}
                                        iconPosition={"left"}
                                        variant={"link"}
                                        color={"gray"}
                                        label="Altro"
                                        onClick={() => {
                                            setIsMenuOpen(false)
                                            setType("other")
                                            dispatch(setOpenAddDocumentsModal(true))
                                        }}
                                    />
                                    <ButtonComponent
                                        iconSize={20}
                                        icon={<AccountantIcon size={"20"} color={colors.brandPrimary[500]} />}
                                        size={"sm"}
                                        iconPosition={"left"}
                                        variant={"link"}
                                        color={"gray"}
                                        label="Documenti contabili"
                                        onClick={() => {
                                            setIsMenuOpen(false)
                                            setType("accountant")
                                            dispatch(setOpenAddDocumentsModal(true))
                                        }}
                                    />
                                </div>
                            )}
                            {
                                <div onClick={(e) => { e.currentTarget.querySelector('input')?.focus() }}
                                    className=" h-14 border border-neutral-200 bg-neutral-100 py-3 px-2.5 pl-6 gap-2 rounded-xl flex flex-row items-center w-full justify-between">
                                    <input onKeyDown={(e) => {
                                        if (e.key === 'Enter' && keycloak.tokenParsed !== undefined && keycloak.tokenParsed.exp !== undefined && textMessage !== '') {
                                            if (keycloakState.socket && keycloakState.socket.readyState === keycloakState.socket.OPEN) {
                                                keycloakState.socket.send(chatState.selectedChat + '£>' + textMessage + '£>' + MessageType.message)
                                                setTextMessage('')
                                                setPage(0)
                                                setWrote(true)
                                                setTimeout(() => {
                                                    setMessages([])
                                                    dispatch(findMessages({ chatId: chatState.selectedChat, filter: { page: 0, itemsPerPage: (chat && chat.notSeenMessages > 0 ? (chat.notSeenMessages + 25) : 25), order: chatState.messageFilter.order, sort: chatState.messageFilter.sort } }))
                                                    dispatch(findByUserId(chatState.usersListAfterSend))
                                                    dispatch(findChats(companyState.findByIdCompanyResponse?.id ?? authState.findMeCompanyResponse?.id!))
                                                }, 200)
                                            }
                                        }
                                    }} onChange={(e) => setTextMessage(e.currentTarget.value)} id={'chat'} value={textMessage}
                                        className=" bg-transparent focus:ring-0 outline-none ring-0 font-medium text-text-md leading-6 text-neutral-600 focus:border-none w-full"
                                        placeholder="Inserisci un messaggio"
                                        disabled={!chat?.active || keycloak.hasRealmRole("admin") || keycloak.hasRealmRole("operator") ||
                                            companyState.findByIdCompanyResponse?.status === CompanyStatus.SUSPENDED ||
                                            (!authState.findMeFinancialAdvisorResponse?.isActive && keycloak.hasRealmRole("financial_advisor")) ||
                                            (!authState.findMeCollaboratorResponse?.isActive && keycloak.hasRealmRole("financial_advisor_collaborator")) ||
                                            (!authState.findMeCompanyResponse?.isActive && keycloak.hasRealmRole("company")) ||
                                            (!authState.findMeReferrersResponse?.isActive && keycloak.hasRealmRole("administrative_company"))}
                                    />
                                    <div className="flex flex-row gap-4 items-center">
                                        <div className=" cursor-pointer" onClick={(e) => {
                                            e.stopPropagation()
                                            if (keycloak.hasRealmRole("company") || keycloak.hasRealmRole("administrative_company")) {
                                                setType("accountant")
                                                dispatch(setOpenAddDocumentsModal(true))
                                            } else {
                                                setIsMenuOpen(open => !open)
                                            }
                                        }
                                        }>
                                            <PaperClipIcon ref={iconRef} />
                                        </div>
                                        <ButtonComponent
                                            key={chatState.selectedChat + '-chat-button-message'}
                                            label={''}
                                            onClick={() => {
                                                if (keycloak.tokenParsed !== undefined && keycloak.tokenParsed.exp !== undefined && textMessage !== '') {
                                                    if (keycloakState.socket && keycloakState.socket.readyState === keycloakState.socket.OPEN) {
                                                        keycloakState.socket.send(chatState.selectedChat + '£>' + textMessage + '£>' + MessageType.message)
                                                        setTextMessage('')
                                                        setPage(0)
                                                        setWrote(true)
                                                        setTimeout(() => {
                                                            setMessages([])
                                                            dispatch(findMessages({ chatId: chatState.selectedChat, filter: { page: 0, itemsPerPage: (chat && chat.notSeenMessages > 0 ? (chat.notSeenMessages + 25) : 25), order: chatState.messageFilter.order, sort: chatState.messageFilter.sort } }))
                                                            dispatch(findByUserId(chatState.usersListAfterSend))
                                                            dispatch(findChats(companyState.findByIdCompanyResponse?.id ?? authState.findMeCompanyResponse?.id!))
                                                        }, 200)
                                                    }
                                                }
                                            }}
                                            color={"blue"}
                                            variant={"solid"}
                                            size={"md"}
                                            iconPosition={"only"}
                                            icon={<ArrowRightIcon size={"20"} color={colors.white} />}
                                            iconSize={24}
                                            disabled={!chat?.active || keycloak.hasRealmRole("admin") || keycloak.hasRealmRole("operator") ||
                                                companyState.findByIdCompanyResponse?.status === CompanyStatus.SUSPENDED ||
                                                (!authState.findMeFinancialAdvisorResponse?.isActive && keycloak.hasRealmRole("financial_advisor")) ||
                                                (!authState.findMeCollaboratorResponse?.isActive && keycloak.hasRealmRole("financial_advisor_collaborator")) ||
                                                (!authState.findMeCompanyResponse?.isActive && keycloak.hasRealmRole("company")) ||
                                                (!authState.findMeReferrersResponse?.isActive && keycloak.hasRealmRole("administrative_company")) ||
                                                keycloakState.socket.readyState !== 1 || !textMessage.trim()
                                            } />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                )
            }
            <AddDocumentsModal document={type!} message={true} />
        </div>
    )
}